import { h } from 'preact';
import * as BaseComp from 'base/bolt/boltApp.js';
import Store from 'store/store';

import 'utils/bolt/tracking';
import { joinClasses } from 'utils/utils';
import { getPageTitle, navigateInternally } from 'utils/bolt/index';
import { getDynamicData, transformPageData } from 'utils/bolt/dynamicData';
import parseQueryString from 'utils/parseQueryString';

import s from 'base/bolt/boltApp.sss';

export default class BoltApp extends BaseComp.default {

	async componentDidMount() {
		super.componentDidMount?.();
		const { previewDataPath } = parseQueryString();
		await Promise.all([
			this.loadGroupPages(previewDataPath),
			this.loadEventPages(previewDataPath)
		]);
		Store.get().set({ dynamicDataLoaded: true });
	}

	async loadGroupPages(previewDataPath) {
		const data = await getDynamicData('group-pages');
		const pages = Object.values(data || {}).map(p => ({
			base: 'bolt',
			id: p.url,
			// Ideally to avoid collision with event pages and regular pages, we should add some kind of prefix:
			// id: `group-${p.url}`,
			title: p.meta?.title,
			data: {},
			type: 'hub',
			path: '/' + p.url + '/',
			customPageComponent: 'group',
			customHeaderLogo: p.customHeaderLogo,
			customFooterLogo: p.customFooterLogo,
		}));

		const defaultTitle = getPageTitle({ page: 'landing' });
		const metaTags = Object.fromEntries(pages.map(p => [p.id, { title: p.title || defaultTitle }]));
		Store.get().appData.doc.metaTags.pageSpecificMetaTags.set(metaTags);

		Store.get().appData.pages.set(Object.fromEntries(pages.map(p => [p.id, p]))).now();
		const desiredPage = data[previewDataPath]?.url;
		if (desiredPage) {
			navigateInternally(desiredPage);
		}
	}

	async loadEventPages(previewDataPath) {
		const data = await getDynamicData('event-pages');
		const pages = Object.values(data || {}).flatMap(transformPageData);

		const defaultTitle = getPageTitle({ page: 'landing' });
		const metaTags = Object.fromEntries(pages.map(p => [p.id, { title: p.title || defaultTitle }]));
		Store.get().appData.doc.metaTags.pageSpecificMetaTags.set(metaTags);

		Store.get().appData.pages.set(Object.fromEntries(pages.map(p => [p.id, p]))).now();
		const desiredPage = data[previewDataPath]?.url;
		if (desiredPage) {
			navigateInternally(desiredPage);
		}
	}

	renderMain(props, state) {
		const base = super.renderMain(props, state);
		const showtimesOpen = Store.get().showtimes?.showtimesOpen;
		if (showtimesOpen) {
			base.attributes.class = joinClasses(base.attributes.class, s.showtimesOpen);
		}
		return base;
	}
}
